module.exports = __webpack_public_path__ + "76ffa34ee08280dbde93dfe5df9b37f0.png";